import React from 'react'
import styled from 'styled-components'
import ScreenWrapper from '../shared/ScreenWrapper'
import styles from '../../utility/styles'
import { GiftSuccess } from '../../utility/icons'
import Text from '../shared/Text'

const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	padding: 64px 24px 96px;
`

const Card = styled.div`
	width: 100%;
	max-width: 560px;
	background: ${styles.colors.darkBackground};
	border: 1px solid var(--tz-hairline, rgba(255, 255, 255, 0.07));
	border-radius: 14px;
	padding: 48px 40px;
	display: flex;
	flex-direction: column;
	align-items: center;
	text-align: center;
	@media only screen and ${styles.breakpoints.mobileL} {
		padding: 32px 20px;
	}
`

const OrderChip = styled.div`
	font-family: ${styles.fonts.geistMono};
	font-size: 12px;
	line-height: 16px;
	font-weight: 500;
	letter-spacing: 0.08em;
	color: ${styles.colors.dimHighlight};
	background: var(--tz-wash, rgba(255, 255, 255, 0.04));
	border: 1px solid var(--tz-hairline, rgba(255, 255, 255, 0.07));
	border-radius: 999px;
	padding: 6px 14px;
	margin: 12px 0 24px;
`

const Divider = styled.hr`
	width: 100%;
	border: 0;
	border-top: 1px solid var(--tz-hairline, rgba(255, 255, 255, 0.07));
	margin: 28px 0 20px;
`

export default function GiveGiftSuccess({ data }) {
	if (!data) return false
	return (
		<ScreenWrapper>
			<Wrapper>
				<Card>
					<GiftSuccess style={{ marginBottom: '20px' }} />
					<Text.Heading type='h3' variant='bold' style={{ textAlign: 'center' }}>Your Gift Order is Confirmed!</Text.Heading>
					<OrderChip>ORDER # {data.order_number}</OrderChip>
					<Text.Body color={styles.colors.lightGray} style={{ marginBottom: '12px' }}>
						An email has been sent to <span style={{ color: styles.colors.dimHighlight, fontWeight: 600 }}>{data.to_email}</span> with instructions on how they can redeem their gift.
					</Text.Body>
					<Text.Body color={styles.colors.lightGray}>
						A confirmation with these instructions will also be sent to you.
					</Text.Body>
					<Divider />
					<Text.Caption variant='bold' color={styles.colors.founders}>Thanks for sharing TezLab with others!</Text.Caption>
				</Card>
			</Wrapper>
		</ScreenWrapper>
	)
}
